<div class="card bg-white border-none">
  <div class="card-header p-3 sm:p-5 pb-0">
    <div class="flex items-center justify-between">
      <p i18n="Share ad modal" class="flex mb-0 pb-0 text-primaryDark text-lg sm:text-xl font-bold">Deli oglas</p>

      <button (click)="close()" class="btn border-transparent shadow-none text-gray hover:text-grayDark fadeInFadeOut"><i
        class="fas fa-times text-lg"></i></button>
    </div>
  </div>
  <div class="card-content">

    <div *ngIf="linkUnavailable" class="text-center py-8">
      <div class="flex justify-center mb-4">
        <i class="fas fa-exclamation-triangle text-3xl text-yellow"></i>
      </div>
      @if (websiteNotLive) {
        <p class="text-grayDark mb-2" i18n="Share ad modal@@shareAdWebsiteNotLive">Vozilo je objavljeno, a vaša spletna stran še ni objavljena, zato povezave za deljenje še ni.</p>
        <p class="text-gray text-sm mb-4" i18n="Share ad modal@@shareAdWebsiteNotLiveHint">Objavite spletno stran v nastavitvah spletne strani. Oglasni portali (Njuškalo, Bolha, Index.hr, Shopaj24) ne vrnejo neposredne povezave do oglasa, zato je ne moremo deliti.</p>
      } @else {
        <p class="text-grayDark mb-4" i18n="Share ad modal">To vozilo še ni objavljeno na nobeni spletni strani.</p>
      }
    </div>

    <ng-container *ngIf="!linkUnavailable">
      <p i18n="Share ad modal">Za deljenje tega oglasa uporabite spodnjo povezavo.</p>

      <div class="my-4">
        <label class="relative"><span i18n="Share ad modal">Spletna povezava</span>
          <input readonly [value]="publicAdUrl" (click)="selectText($event)">

          <span class="absolute right-0 mr-1 z-20 mt-3"><button (click)="copyToClipboard()"
                                                                class="btn btn-sm border-none shadow-none text-primary hover:text-primaryDark focus:text-primaryDark bg-white"><i
            class="far fa-copy text-lg"></i></button></span>
        </label>
      </div>

      <div class="mb-3">
        <app-share-vehicle-widget [url]="publicAdUrl"></app-share-vehicle-widget>
      </div>
    </ng-container>

    <div class="mt-12 flex flex-row justify-end">
      <button class="btn btn-grayDark-link mr-1" (click)="close()" i18n>Zapri</button>
    </div>
  </div>
</div>

